export default function asyncWait(ms) {
    return new Promise(function (resolve, reject) {
      try {
        setTimeout(() => resolve("done"), ms || 3000);
      } catch (err) {
        reject(err);
      }
    });
  }
  